const MyButton = (props) => {
  const {
    size = "normal",
    variant = "contained",
    color,
    textColor = "white",
    children,
    className,
    disabled = false,
    type = "button",
    onClick = () => {},
    ...rest
  } = props;

  return (
    <button
      className={`${className || ""} rounded flex items-center justify-center ${
        disabled
          ? "pointer-events-none opacity-60"
          : "opacity-[0.95] hover:opacity-100 "
      } ${
        size === "small"
          ? "sm:text-base text-sm h-8 px-4"
          : size === "large"
          ? "md:text-xl sm:text-lg text-base h-[56px] sm:px-8 px-4"
          : "md:text-lg sm:text-base text-sm h-[48px] sm:px-6 px-2"
      } ${
        variant === "contained" && color === "primary"
          ? "bg-primary text-white"
          : variant === "contained" && !color
          ? "bg-[#DDDDDD] text-[#222222]"
          : ""
      } ${
        variant === "contained" && color === "primary"
          ? "bg-primary"
          : variant === "contained" && color
          ? `bg-[${color}]`
          : variant === "contained" && !color
          ? "bg-[#DDDDDD]"
          : ""
      } ${
        variant === "outlined" && color === "primary"
          ? "text-primary border border-primary"
          : variant === "outlined" && !color
          ? "border border-[#DDDDDD] text-[#222222]"
          : ""
      }`}
      style={{
        backgroundColor:
          variant === "contained" && color && color !== "primary"
            ? color
            : undefined,
        color: color === "primary" ? undefined : textColor,
        ...rest.style,
      }}
      disabled={disabled}
      type={type}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default MyButton;
